import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {DASHBOARD} from "../../../containers/dashboard-container/dashboard-container.consts";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import type {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";

export class ScoresListHeaderModuleMobileDateViewModel extends BaseViewModel {
  date: Date;
  _name: String;
  sportName: String;
  linkType: BaseLinkModel;
  isLinkTag: Boolean;
  datetimeUtils: DatetimeUtils;

  constructor(date: Date, name: String, sportName: String, linkType: BaseLinkModel, isLinkTag: Boolean, datetimeUtils: DatetimeUtils, isWidget: Boolean) {
    super(null);

    this.date = date;
    this.sportName = sportName;
    this._name = name;
    this.linkType = linkType;
    this.isLinkTag = isLinkTag;
    this.datetimeUtils = datetimeUtils;
    this.isWidget = isWidget;
  }

  get day(): String {
    return this.date.getDate();
  }

  get name(): String {
    return this._name;
  }

  get linkModel(): String {
    const filter: String = this.datetimeUtils.isToday(this.date) ? DASHBOARD.FILTERS.all : this.datetimeUtils.toURLDate(this.date);
    const linkModel = new this.linkType(filter, this.sportName, true, false, this.isLinkTag);
    linkModel.replace = this.isWidget;

    return linkModel;
  }
}
